// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './_collection-list.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--collection-list").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("collection-list-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.collection-list').find(".swiper-button-prev").addClass("collection-list-btn-prev-" + index);
        $this.parents('.collection-list').find(".swiper-button-next").addClass("collection-list-btn-next-" + index);

        var swiper = new Swiper(".collection-list-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 2,
            spaceBetween: 13,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            breakpoints: {
                // when window width is >= 680ppx
                680: {
                    slidesPerView: 4,
                    spaceBetween: 36
                }
            },

            // // Navigation arrows
            navigation: {
              nextEl: ".collection-list-btn-next-" + index,
              prevEl: ".collection-list-btn-prev-" + index
            },

            // Pagination
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: 'true'
            },
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});
